import { render, staticRenderFns } from "./OnboardingFrontdocCamera.vue?vue&type=template&id=73ee4b08"
import script from "./OnboardingFrontdocCamera.vue?vue&type=script&lang=js"
export * from "./OnboardingFrontdocCamera.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports